export const ROLLOUT_STATE = 'rollout';

export type RolloutState = { readonly state: typeof ROLLOUT_STATE; readonly percent: number };

const MIN_PERCENT = 0;
const MAX_PERCENT = 100;

function isPercent(value: unknown): boolean {
  return Number.isInteger(value) && (value as number) >= MIN_PERCENT && (value as number) <= MAX_PERCENT;
}

export function isRolloutState(value: unknown): value is RolloutState {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const { state, percent } = value as { state?: unknown; percent?: unknown };

  return state === ROLLOUT_STATE && isPercent(percent);
}
